export default __webpack_public_path__ + "static/media/Activelog.4974220b.svg";